import { Form } from 'factorial-form'

export class AssignEsignatureForm extends Form {
  constructor(values: {}) {
    super(values, {
      requestEsignature: 'boolean',
    })
  }
}
